import { render, staticRenderFns } from "./RegisteredRequest.vue?vue&type=template&id=0bc1ce2c&scoped=true"
import script from "./RegisteredRequest.vue?vue&type=script&lang=js"
export * from "./RegisteredRequest.vue?vue&type=script&lang=js"
import style0 from "./RegisteredRequest.vue?vue&type=style&index=0&id=0bc1ce2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1ce2c",
  null
  
)

export default component.exports